import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";

export default function Footer() {
return ( <footer className="footer-container bg-[#070d18] text-white py-12">

  <div className="max-w-4xl mx-auto flex flex-col items-center gap-1">

    {/* ECEA Socials */}
    <p className="footer-section-title">
      ECEA SOCIALS
    </p>

    <div className="flex gap-6">

      <a href="https://youtube.com/@ecea_ceg" target="_blank" rel="noreferrer" className="social-icon">
        <YouTubeIcon sx={{ color: "#FF0000" }} fontSize="medium" />
      </a>

      <a href="https://www.linkedin.com/in/ecea-ceg" target="_blank" rel="noreferrer" className="social-icon">
        <LinkedInIcon sx={{ color: "#0A66C2" }} fontSize="medium" />
      </a>

      <a href="https://instagram.com/ecea_ceg" target="_blank" rel="noreferrer" className="social-icon">
        <InstagramIcon sx={{ color: "#E1306C" }} fontSize="medium" />
      </a>

      <a href="mailto:eceaobs26@gmail.com" className="social-icon">
        <EmailIcon sx={{ color: "white" }} fontSize="medium" />
      </a>

    </div>

    {/* Crafted By */}
    <p className="text-white/60 text-sm mt-2">
      Crafted by
    </p>

    {/* Developer Signature */}
    <div className="credit-glow flex flex-col items-center leading-tight">

  <a
    href="https://www.linkedin.com/in/karthiktamilselvann/"
    target="_blank"
    rel="noreferrer"
    className="credit-name"
  >
    Karthik Tamil Selvann R
  </a>

  <div className="flex items-center gap-3 mt-1">

    <span className="rollno">
      2022105711
    </span>

    <a href="https://instagram.com/iamkarthie" target="_blank" rel="noreferrer" className="social-icon">
        <InstagramIcon sx={{ color: "#E1306C" }} fontSize="medium" />
      </a>

  </div>

</div>
    {/* Copyright */}
    <p className="text-xs text-white/40 mt-3">
      © {new Date().getFullYear()} Electronics and Communication Engineering Association
    </p>

  </div>

</footer>

);
}

